// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	document.documentElement.style.setProperty(
		'--header-offset',
		document.getElementById("header").clientHeight + document.getElementById("header").offsetTop + 'px'
	);

	if( document.querySelector( "#form_id-1173" ) ){

		let select_a_destination = document.querySelectorAll( "input[name*='select_a_destination']" )

		let _access_token = document.createElement( "input" );
		_access_token.type = "hidden"
		_access_token.name = "_access_token"
		_access_token.value = "21adc27b-57ac-4ec7-a92f-b5425730a942,07d403fb-d10e-4632-8cb5-54aa1c58b2c1,";
		document.querySelector( "#form_id-1173" ).appendChild( _access_token );

		select_a_destination.forEach( ( item, index ) => {

			item.addEventListener( "change", ( e ) => {

				if( e.target.checked ){
					switch( e.target.value ){
						case "Paséa Hotel & Spa":
							_access_token.value += "ff0b5fd0-fa69-4981-8803-3efac8128137,2d84b561-d52b-40e5-ad95-ef1130113e8e,";
							break;
						case "The Meritage Resort and Spa":
							_access_token.value += "2229adbc-977f-4bb6-9986-a41ff2ee3850,2be376f6-1c1d-4bf9-9442-b2875796e11f,";
							break;	
						case "Koa Kea Hotel & Resort":
							_access_token.value += "9f0da36e-b137-4520-8e2f-4fabe9f6bfd9,4ebe5fdc-13e1-4763-bc66-7ae643a0c62b,";
							break;
						case "Hotel Viata":
							_access_token.value += "21adc27b-57ac-4ec7-a92f-b5425730a942,07d403fb-d10e-4632-8cb5-54aa1c58b2c1,";
							break;
						case "Grand Reserve":
							_access_token.value += "2229adbc-977f-4bb6-9986-a41ff2ee3850,2be376f6-1c1d-4bf9-9442-b2875796e11f,";
							break;	
					}
				}else{

					let value = _access_token.value;
					switch( e.target.value ){
						case "Paséa Hotel & Spa":
							_access_token.value = value.replace("ff0b5fd0-fa69-4981-8803-3efac8128137,2d84b561-d52b-40e5-ad95-ef1130113e8e,", "") ;
							break;
						case "The Meritage Resort and Spa":
							_access_token.value = value.replace("2229adbc-977f-4bb6-9986-a41ff2ee3850,2be376f6-1c1d-4bf9-9442-b2875796e11f,", "") ;
							break;	
						case "Koa Kea Hotel & Resort":
							_access_token.value = value.replace("9f0da36e-b137-4520-8e2f-4fabe9f6bfd9,4ebe5fdc-13e1-4763-bc66-7ae643a0c62b,", "") ;
							break;
						case "Hotel Viata":
							_access_token.value = value.replace("2229adbc-977f-4bb6-9986-a41ff2ee3850,2be376f6-1c1d-4bf9-9442-b2875796e11f,", "") ;
							break;
					}		

				}

			} )

		} )
	}	

	//signup form
	if( document.querySelector( "#form_id-2263" ) ){

		function htmlDecode(input) {
			var doc = new DOMParser().parseFromString(input, "text/html");
			return doc.documentElement.textContent;
		}

		let interests = [...document.querySelectorAll( "[name*=interests]" )]

		let _access_token = document.createElement( "input" )
		_access_token.type = "hidden"
		_access_token.name = "_access_token"
		document.querySelector( "#form_id-2263" ).appendChild( _access_token )

		interests.forEach( ( item, index ) => {
			item.addEventListener( "change", () => {

				let label = htmlDecode( item.parentNode.querySelector( "label" ).innerHTML )
				console.log( "input[name='_multiple_list_ids["+label+"]']" );
				if( !document.querySelector( "input[name='_multiple_list_ids["+label+"]']" ) ) return;

				let token = document.querySelector( "input[name='_multiple_list_ids["+label+"]']" ).value
				let tokens = _access_token.value

				console.log( item.checked );
				console.log( token );

				if( item.checked === true )
					tokens += "," + token 
				else if( item.checked === false )
					tokens = tokens.replace( "," + token, "" )
				
				console.log( tokens );

					_access_token.value = tokens

			} )
		} )

	}

	$(document).ready(function () {
		$('.header__burger, .main-nav__close').click(function() {
		    $('.header').toggleClass('nav-open');
		    $('.main-nav').toggleClass('open');
			var text = $('.header__burger-label').text();
			// $('.header__burger-label').text(
			// 	text == "Menu" ? "Close" : "Menu");
		});
		$('[data-fancybox]').fancybox({
			buttons: [
				//"zoom",
				//"share",
				//"slideShow",
				//"fullScreen",
				//"download",
				//"thumbs",
				"close"
			],
			wheel:false
		});
		
		$("#primary-nav li").hover(function(){
            var target = $(this);
            window.mytimeout = setTimeout(function(){
                target.addClass("hover");
                $('ul.submenu',target).fadeIn(300);
            }, 400);
        }, function(){
            if($(this).hasClass("hover")) {
                $(this).removeClass("hover");
                $('ul.submenu',this).fadeOut(300);
            } else {
                clearTimeout(window.mytimeout);
            }
        });


		if( document.querySelector( "#primary-nav li" ) ){
			$("#primary-nav li").each(function () {
				if ($(this).children('.submenu').length) {
					$(this).addClass('has-menu');
				}
			});
		}	

		if(window.location.hash) {
			setTimeout(() => {$('html, body').animate({scrollTop: $(window.location.hash).offset().top - $('.header').height()}, 500);}, 1000);
			
		}


		$('.js-widget').click(function(e) {
			if( !document.querySelector('.js-widget').href.includes('http') ){
				console.log('Click book');
				e.preventDefault();
				$('.boooking-block').toggleClass('open');
			}
		});
		$('.booking-close').click(function() {
		    $('.boooking-block').toggleClass('open');
		});
		$('.event-venues-austin-tx #content .sn-5, .event-venues-austin-tx #content .sn-12').after("<br>");

		
	}); 

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	if (document.querySelector(".restaurant-austin")) {
		if(document.querySelector(".opentable__block")) {
			let openTableContent = document.querySelector(".opentable__block");
			let targetElement = document.querySelector(".hero");
			
			targetElement.parentNode.insertBefore(openTableContent, targetElement);	
		}
	}

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	let fij = document.getElementById('75429');

	if (fij){
		if (st >= 1345){
			fij.classList.add('position');
		} else{
			fij.classList.remove('position');
		}
	}

	let fij2 = document.getElementById('80814');

	if (fij2){
		if (st >= 1196){
			fij2.classList.add('position');
		} else{
			fij2.classList.remove('position');
		}
	}

	let fij3 = document.getElementById('75390');

	if (fij3){
		if (st >= 1198){
			fij3.classList.add('position');
		} else{
			fij3.classList.remove('position');
		}
	}
	
	let fij4 = document.getElementById('561488');

	if (fij4){
		if (st >= 675){
			fij4.classList.add('position');
		} else{
			fij4.classList.remove('position');
		}
	}

	let fij5 = document.getElementById('64342');

	if (fij5){
		if (st >= 1100){
			fij5.classList.add('position');
		} else{
			fij5.classList.remove('position');
		}
	}

}
